const React = require("react");
const { usePrintful } = require("../context/PrintfulContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;

const DropshippingOrders = () => {
  const { api, t } = usePrintful();
  const resource = useResource(() => api.getOrders({ page: 1, limit: 100 }), [api]);
  const [busy, setBusy] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const orders = resource.data?.orders || [];

  const run = async (order, action, success) => {
    setBusy(order._id); setMessage(""); setError("");
    try { await action(); setMessage(success); await resource.reload(); }
    catch (requestError) { setError(requestError.message); }
    finally { setBusy(""); }
  };

  const createOrder = (order) => {
    const orderId = order.orderId?._id || order.orderId;
    if (!orderId || !window.confirm(t("h_pf_confirm_send_order", "Send this paid order to Printful? Production charges may apply."))) return;
    run(order, () => api.createSupplierOrder(orderId, order.sellerId?._id || order.sellerId), t("h_pf_order_sent", "Order sent to Printful."));
  };

  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_pf_orders_title", "Printful orders"),
      description: t("h_pf_orders_desc", "Supplier status, tracking and fulfillment errors."),
      action: h(Button, { variant: "secondary", disabled: resource.loading || Boolean(busy), onClick: resource.reload }, t("h_pf_refresh", "Refresh")),
    }),
    message ? h("div", { className: "pfds-success", role: "status" }, message) : null,
    error ? h("div", { className: "pfds-alert", role: "alert" }, error) : null,
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !orders.length, reload: resource.reload, t },
      h("div", { className: "pfds-table-wrap" }, h("table", { className: "pfds-table" },
        h("thead", null, h("tr", null,
          h("th", null, t("h_pf_order", "Order")),
          h("th", null, t("h_pf_status", "Status")),
          h("th", null, t("h_pf_tracking", "Tracking")),
          h("th", null, t("h_pf_error", "Error")),
          h("th", null, t("h_pf_actions", "Actions"))
        )),
        h("tbody", null, ...orders.map((order) => {
          const orderId = order.orderId?._id || order.orderId;
          return h("tr", { key: order._id },
            h("td", null, order.dropshippingOrderId || String(orderId || "").slice(-10) || "—"),
            h("td", null, h(StatusBadge, { status: order.supplierStatus || order.status, t })),
            h("td", null, order.trackingUrl ? h("a", { href: order.trackingUrl, target: "_blank", rel: "noopener noreferrer" }, order.trackingNumber || t("h_pf_track", "Track")) : "—"),
            h("td", null, order.errorSafeMessage || "—"),
            h("td", null, h("div", { className: "pfds-row" },
              !order.supplierOrderId ? h(Button, { disabled: busy === order._id || !orderId, onClick: () => createOrder(order) }, order.errorSafeMessage ? t("h_pf_retry_order", "Retry order") : t("h_pf_send_order", "Send order")) : null,
              order.supplierOrderId ? h(Button, { variant: "secondary", disabled: busy === order._id, onClick: () => run(order, () => api.syncOrder(order._id), t("h_pf_order_synced", "Order status updated.")) }, t("h_pf_sync", "Sync")) : null
            ))
          );
        }))
      ))
    )
  );
};

module.exports = { DropshippingOrders };
